/**
 * Canonical ticker normalization for Oracle Insight.
 *
 * Handles known Schwab export variants that differ from the FMP/market standard.
 * Converts dots to hyphens (BRK.B → BRK-B) as holdingsService already does,
 * and resolves known no-separator variants (BRKB → BRK-B).
 *
 * Extend TICKER_ALIASES as new variants are discovered.
 */

const TICKER_ALIASES: Record<string, string> = {
  'BRKB':  'BRK-B',
  'BRKA':  'BRK-A',
};

export function normalizeTicker(raw: string): string {
  if (!raw) return raw;
  const upper = raw.trim().toUpperCase().replace(/\./g, '-');
  return TICKER_ALIASES[upper] ?? upper;
}
